import { render } from "./TextCopier.vue?vue&type=template&id=a057950a&scoped=true"
import script from "./TextCopier.vue?vue&type=script&lang=js"
export * from "./TextCopier.vue?vue&type=script&lang=js"

import "./TextCopier.vue?vue&type=style&index=0&id=a057950a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a057950a"]])

export default __exports__